import { Navigate } from 'react-router-dom';

const Protected = ({ isAdmin, role, children, adminInitialized, isCheckingPermission }) => {
  // Show loading if admin role is not initialized yet or still checking permissions
  if (!adminInitialized || isCheckingPermission) {
    return (
      <div className="loaderpage">
        <div className="loader-box">
          <div className="spinner"></div>
        </div>
      </div>
    );
  }
  
  // Allow access if sessionStorage indicates admin (set by Authen after successful check)
  const sessionIsAdmin = typeof window !== 'undefined' && window.sessionStorage && window.sessionStorage.getItem('isUniformAdmin') === '1';

  if (!isAdmin && !sessionIsAdmin) {
    return <Navigate to={`/auth/${role}`} replace />;
  }
  
  return children;
};
export default Protected;
